export const ALGORITHMS = [
  {
    label: "HS256",
    value: "HS256",
  },
  {
    label: "HS384",
    value: "HS384",
  },
  {
    label: "HS512",
    value: "HS512",
  },
  {
    label: "RS256",
    value: "RS256",
  },
];

export const DEFAULT_CLAIMS_STRING =
  '{\n\t"iss": "YOUR_ISSUER_GOES_HERE",\n\t"sub": "YOUR_SUBJECT_GOES_HERE",\n\t"aud": "YOUR_AUDIENCE_GOES_HERE",\n\t"iat": {{currentTimeSeconds}},\n\t"exp": {{plus currentTimeSeconds 1200}}\n\t}';
export const DEFAULT_FORM_STATE = {
  name: "JWT",
  description: "",
  headerName: "Bearer",
  algorithm: "HS256",
  isBase64Secret: false,
  secret: "",
  claims: DEFAULT_CLAIMS_STRING,
  useAsVariable: false,
};
